import styled from "styled-components"

const Container = styled.button`
    background-color: ${({background})=> background};
    color: ${({color})=> color};
    border-radius: ${({radius})=> radius};
    width: ${({width})=> width};
    padding: ${({padding})=> padding};
    font-size: ${({fontSize})=> fontSize};
    text-align: center;
    line-height: 40px;
    height: 40px;
    font-weight: var(--font-weight-md);
`
const Button = ({text,background, color= "#fff", width= "320px", radius="10px",handleClick, handleMouseEnter, handleMouseLeave, type="button", padding= "0 10px", fontSize= "16px"}) => {

  return (
    <Container background={background} color={color} width={width} radius={radius} onClick={handleClick} type={type} padding={padding} fontSize={fontSize} onMouseOver={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {text}
    </Container>
  )
}

export default Button